






























































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import OrgSuggest from '../form pickers/orgSuggest.vue';
import { PartnerApi } from '@/api';
import Toast from '@/components/display/toast.vue';
import { number } from '@amcharts/amcharts4/core';

@Component({
	components: {
		OrgSuggest,
	},
	validations: {},
})
export default class AddOrgToProduct extends Vue {
	public selectedOrg = {
		id: '',
		orgType: '',
		name: '',
		adminId: '',
	};
	@Prop(Number)
	public readonly productId?: number;
	public partner = true;
	public async addProductToPartnerOrg() {
		try {
			const response = await new PartnerApi().partnerAddProduct(parseInt(this.selectedOrg.id, 10), {
				data: { productId: this.productId },
			});
		} catch (e) {
			console.log(e);
			new Toast().makeToast(e, 'Error Adding Partner Product', 'danger', false);
		}
		this.$emit('success');
		new Toast().makeToast(
			'Product was successfully added to the partner org',
			'Success Adding Partner Product',
			'success',
			false,
		);
	}

	public clearSelectedOrg() {
		this.selectedOrg = {
			id: '',
			orgType: '',
			name: '',
			adminId: '',
		};
	}
}
